import { render, staticRenderFns } from "./ErrorBoundary.vue?vue&type=template&id=02a95e1c&scoped=true&"
import script from "./ErrorBoundary.vue?vue&type=script&lang=js&"
export * from "./ErrorBoundary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a95e1c",
  null
  
)

export default component.exports